export interface OverlayElementPropertiesDto {
  opacity?: number;
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
  borderStyle?: 'solid' | 'dashed' | 'dotted';
  zIndex?: number;
}

export const DefaultOverlayElementProperties: OverlayElementPropertiesDto = {
  opacity: 1,
  backgroundColor: '#d3d3d3',
  borderColor: '#000000',
  borderWidth: 2,
  borderStyle: 'solid',
  zIndex: 0
};
